<span [title]="activistTypeTooltip$ | async" class="badge badge-xxs badge-icon rounded-pill" [ngClass]="badgeColor">
  <i class="f-i f-i-flag"></i>
</span>
